import { render } from "./PersonFilterSidebar.vue?vue&type=template&id=db296cc6&scoped=true&ts=true"
import script from "./PersonFilterSidebar.vue?vue&type=script&lang=ts"
export * from "./PersonFilterSidebar.vue?vue&type=script&lang=ts"

import "./PersonFilterSidebar.vue?vue&type=style&index=0&id=db296cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db296cc6"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSeparator});
